import { useCallback } from 'react'

import getLoginUser, { User } from 'core/application/account/loginUser'

import useQueryRequest from './useQueryRequest'
import useSharedState, { SharedStateKeys } from './useSharedState'

/**
 * @deprecated The method should not be used. Please use useLoginUserV2 instead.
 */
const useLoginUser = (): [User, Function, () => Promise<void>, boolean] => {
  const [user, setUser] = useSharedState<User>(SharedStateKeys.LoginUser, null)

  const [, isLoading, sendQueryRequest] = useQueryRequest<User>()

  const reloadUser = useCallback(async () => {
    const result = await sendQueryRequest(() => getLoginUser())
    setUser(result)
  }, [])

  return [user, setUser, reloadUser, isLoading]
}

export default useLoginUser

export const useLoginUserV2 = (): {
  user: User
  setUser: (newState: User) => void
  reloadUser: () => Promise<void>
  isLoading: boolean
} => {
  const [user, setUser] = useSharedState<User>(SharedStateKeys.LoginUser, null)

  const [, isLoading, sendQueryRequest] = useQueryRequest<User>()

  const reloadUser = useCallback(async () => {
    const result = await sendQueryRequest(() => getLoginUser())
    setUser(result)
  }, [])

  return {
    user,
    setUser,
    reloadUser,
    isLoading,
  }
}
